import cn from "classnames";

export interface RequestsTab {
  id: string;
  label: string;
  icon: React.ComponentType<{ size: number; color: string }>;
  count?: number;
}

interface RequestsTabsProps {
  items: RequestsTab[];
  activeId: string;
  onChange: (id: string) => void;
}

export default function RequestsTabs({ items, activeId, onChange }: RequestsTabsProps) {
  return (
    <div className="p-6 radius-3xl surface-base-fill flex flex-wrap justify-start items-center gap-2">
      {items.map(function renderTab(item) {
        const isActive = item.id === activeId;
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange(item.id)}
            className={cn(
              "px-3 py-2.5 flex justify-start items-center gap-2 radius-sm text-label-md cursor-pointer",
              isActive ? "background-brand-fill text-white" : "surface-component-fill content-action-neutral",
            )}>
            <Icon size={20} color="currentColor" />
            {item.label}
            {item.count != null && item.count > 0 && (
              <span
                className={cn(
                  "min-w-5 h-5 px-1.5 flex items-center justify-center rounded-md text-label-xs",
                  isActive
                    ? "background-static-white content-action-brand"
                    : "surface-neutral-subtle content-base-secondary",
                )}>
                {item.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
